import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';
import ToolFinderQuiz from '../home/components/ToolFinderQuiz';
import { useSEO } from '../../hooks/useSEO';

const SITE_OG_IMAGE = 'https://public.readdy.ai/ai/img_res/2a35743cdb9600edc45f9b5e09018b91.jpg';

export default function QuizPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://toolnova.ai';

  useSEO({
    title: 'AI Tool Finder Quiz - Find Your Perfect AI Tool in 60 Seconds | ToolNova',
    description: 'Not sure which AI tool is right for you? Take our 60-second quiz and get personalized AI tool recommendations based on your goals and workflow.',
    keywords: 'AI tool quiz, find AI tools, AI tool recommendation, best AI tool for me, AI tool finder',
    canonical: `${siteUrl}/quiz`,
    ogTitle: 'AI Tool Finder Quiz - Find Your Perfect AI Tool | ToolNova',
    ogDescription: 'Answer 5 quick questions and get personalized AI tool recommendations based on your goals, budget, and workflow.',
    ogType: 'website',
    ogUrl: `${siteUrl}/quiz`,
    ogImage: SITE_OG_IMAGE,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: 'AI Tool Finder Quiz',
      description: 'Answer 5 quick questions and get personalized AI tool recommendations based on your goals, budget, and workflow.',
      url: `${siteUrl}/quiz`,
      applicationCategory: 'UtilityApplication',
      operatingSystem: 'Web',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'USD',
      },
      publisher: {
        '@type': 'Organization',
        name: 'ToolNova',
        url: siteUrl,
      },
    },
  });

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col">
      <Navbar />
      <main className="flex-1">
        {/* SEO H1 header */}
        <div className="pt-24 pb-0 px-6 text-center">
          <h1 className="sr-only">AI Tool Finder Quiz - Personalized AI Tool Recommendations</h1>
        </div>
        <ToolFinderQuiz />
      </main>
      <Footer />
    </div>
  );
}
